import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThemeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Theme",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.7 17.89v.87c0 1.1-.9 2-2 2h-1.44c-1.1 0-2-.9-2-2v-.87H5.39c-1.3 0-2.49-.49-3.39-1.3v9.69c0 1.94 1.57 3.5 3.51 3.51h21A3.523 3.523 0 0 0 30 26.28v-9.71a5 5 0 0 1-3.37 1.31h-7.92Zm-3.44-2.84h1.48c.21 0 .38.17.38.38v3.32c0 .21-.17.38-.38.38h-1.48a.38.38 0 0 1-.38-.38v-3.32c0-.21.17-.38.38-.38m11.22-6.42h-3.06V4.07c0-1.03-.84-1.87-1.87-1.87h-11.1c-1.03 0-1.87.84-1.87 1.87v4.56H5.52c-1.94 0-3.51 1.57-3.52 3.51v1.41c.36 1.57 1.74 2.73 3.39 2.73h7.91v-.87a2 2 0 0 1 2-2h1.48a2 2 0 0 1 2 2v.87h7.91a3.48 3.48 0 0 0 3.3-2.59v-1.55c0-1.94-1.58-3.51-3.52-3.51Zm-5.64 0h-9.67V4.79h9.67z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.12 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h6.83c1.89 0 3.43 1.54 3.43 3.43v20.57c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h6.83c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "8.71",
        cy: "22.43",
        r: "1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.71 24.71a2.29 2.29 0 1 1 0-4.58c1.27 0 2.29 1.02 2.29 2.29s-1.03 2.29-2.29 2.29M25.86 29.28H12.15a1.14 1.14 0 1 1 0-2.28h13.71c.63 0 1.14-.51 1.14-1.14v-8a1.14 1.14 0 1 1 2.28 0v8c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.46 25.89c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l11.87-11.87c.22-.22.33-.5.33-.81s-.12-.59-.33-.81l-4.83-4.83a1.14 1.14 0 0 0-1.25-.25c-.58.24-1.25-.03-1.49-.62-.24-.58.03-1.25.62-1.49 1.29-.53 2.75-.24 3.74.74l4.83 4.83c.65.65 1 1.51 1 2.43s-.36 1.78-1 2.42L15.27 25.55c-.22.22-.52.33-.81.33Z"
      })]
    })
  }));
};
ThemeIcon.displayName = 'ThemeIcon';